import { updateRedeemTemplate } from 'actions/redeemTemplates'
import useDispatch from 'hooks/useDispatch'
import { buildTranslate } from 'locales'
import React, { useState } from 'react'

import gift from 'assets/images/redeem-manager/welcome_gift.svg'
import ActionModal from './ActionModal'

type Props = {
  templateId: number
  name: string
  isOpen: boolean
  onClose: () => void
  onActivate: () => void
}

const t = buildTranslate('redeem_manager.actions.activate')

const ActivateModal: React.FC<Props> = ({
  templateId,
  name,
  isOpen,
  onActivate,
  onClose,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const dispatch = useDispatch()

  async function activate() {
    setIsSubmitting(true)
    const result = await dispatch(
      updateRedeemTemplate(templateId, {
        state: 'published',
      })
    )
    setIsSubmitting(false)

    if (result.error) {
      setError(
        t('error', {
          name,
        })
      )
      return
    }

    setError(null)
    onActivate()
  }

  return (
    <ActionModal
      isOpen={isOpen}
      isSubmitting={isSubmitting}
      image={gift}
      title={t('title')}
      headline={t('headline')}
      description={t('description')}
      submitText={t('submit_button')}
      error={error}
      onClose={onClose}
      onSubmit={activate}
    />
  )
}

export default ActivateModal
